<template>
  <div>
    <search-esim-profile-list @submit="submitSearch" />

    <div class="simiot-table-operation-buttons" v-if="canOperate">
      <a-space>
        <a-button type="primary" @click="unsetFallback" :loading="acting">取消 Fallback</a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a @click="updateProfileEim(record)" :disabled="updatingProfileId === record.profile_id">更新</a>
        <template v-if="canOperate">
          <a-divider type="vertical" />
          <a @click="doOp('enable', record)">启用</a>
          <a-divider type="vertical" />
          <a @click="doOp('disable', record)">禁用</a>
          <a-divider type="vertical" />
          <a @click="doOp('fallback', record)">设 Fallback</a>
          <a-divider type="vertical" />
          <a @click="confirmDelete(record)">删除</a>
        </template>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import {
  findEsimProfileLinks,
  enableEsimProfile,
  disableEsimProfile,
  deleteEsimProfile,
  setEsimFallbackProfile,
  unsetEsimFallbackProfile
} from '@/api/esim'
import { updateProfileEimData } from '@/api/profile'
import Pagination from '@/components/Pagination'
import SearchEsimProfileList from '@/views/esims/info/ProfileListSearch'

export default {
  name: 'ShowEsimProfileList',
  components: {
    Pagination,
    SearchEsimProfileList
  },
  props: {
    id: { type: Number, required: true }
  },
  data() {
    return {
      loading: false,
      acting: false,
      updatingProfileId: 0,
      data: [],
      pagination: {
        total_count: 0
      },
      query: {
        per_page: 10
      },
      columns: [
        { title: 'ICCID', dataIndex: 'iccid', width: 220 },
        { title: '设备侧状态', dataIndex: 'status_name', width: 100 },
        { title: 'eIM状态', dataIndex: 'eim_status', width: 100 },
        { title: 'SM-DP+状态', dataIndex: 'profile_status', width: 120 },
        {
          title: 'Fallback',
          dataIndex: 'is_fallback',
          width: 90,
          customRender: (v) => (v ? '是' : '否')
        },
        { title: '关联时间', dataIndex: 'linked_at', width: 160 },
        { title: '操作', dataIndex: 'actions', scopedSlots: { customRender: 'actions' }, width: 320 }
      ]
    }
  },
  computed: {
    canOperate() {
      return hasPermission('agent_esims/operate_profile')
    }
  },
  created() {
    this.fetchData()
  },
  activated() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, { per_page: this.query.per_page }, search)
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      findEsimProfileLinks(this.id, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data || []
          this.pagination = res.pagination || { total_count: 0 }
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    updateProfileEim(record) {
      if (!record || !record.profile_id) return
      this.updatingProfileId = record.profile_id
      updateProfileEimData(record.profile_id).then((res) => {
        this.updatingProfileId = 0
        if (res.code === 0) {
          this.$message.success(res.message || '操作成功，请稍后刷新查看')
        }
      }).catch(() => {
        this.updatingProfileId = 0
      })
    },
    confirmDelete(record) {
      const vm = this
      this.$confirm({
        title: '确认删除该 Profile？',
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return vm.doOp('delete', record)
        }
      })
    },
    doOp(type, record) {
      const body = { iccid: record.iccid }
      let req
      if (type === 'enable') req = enableEsimProfile(this.id, body)
      else if (type === 'disable') req = disableEsimProfile(this.id, body)
      else if (type === 'delete') req = deleteEsimProfile(this.id, body)
      else if (type === 'fallback') req = setEsimFallbackProfile(this.id, body)
      else return Promise.resolve()
      this.acting = true
      return req.then((res) => {
        this.acting = false
        if (res.code === 0) {
          const msg = (res.data && res.data.message) || '指令已提交，请在操作记录查看结果'
          this.$message.success(msg)
          this.fetchData()
        }
      }).catch(() => {
        this.acting = false
      })
    },
    unsetFallback() {
      this.acting = true
      unsetEsimFallbackProfile(this.id).then((res) => {
        this.acting = false
        if (res.code === 0) {
          this.$message.success((res.data && res.data.message) || '指令已提交')
          this.fetchData()
        }
      }).catch(() => {
        this.acting = false
      })
    }
  }
}
</script>
